import { applyMiddleware, legacy_createStore } from 'redux';
import { thunk } from 'redux-thunk';
import * as reduxLogger from 'redux-logger';
import pkgConfig from '../../package.json';

import allReducers from './reducers';

const { createLogger } = reduxLogger;

// Only use redux-logger if explicitly enabled in package.json config
const useReduxLogger = pkgConfig.config && pkgConfig.config['redux-logger'];

const configureStore = (initialState) => {
  const middleware = [thunk];

  if (useReduxLogger) {
    const logger = createLogger({
      collapsed: true,
    });
    middleware.push(logger);
  }

  const store = legacy_createStore(allReducers, applyMiddleware(...middleware));
  return store;
};

export default configureStore();
